<div class="">
	<h3 class="mb-4">Forgot Password</h3>
	<form [formGroup]="form" (ngSubmit)="onSubmit()" class="mb-3">
		<div class="alert alert-danger" *ngIf="message">
			{{message}}
		</div>

		<input [value]="agent.username" name="username" type="hidden" class="form-control" id="floatingUsername">

		<div class="mb-5">
			<label for="input-otp" class="form-label">2FA Token</label>
			<br>
			<nz-input-otp id="input-otp" [nzLength]="6" formControlName="otp" appAutoFocus name="otp"></nz-input-otp>
		</div>
		<ng-container *ngIf="sentOtp">
			<ul>
				<ng-container *ngFor="let channel of sentOtp.availableChannels">
					<li *ngIf="channel == sentOtp.sentViaChannel">
						<a class="btn btn-link btn-sm" (click)="reSend(channel)">Resend {{channel}} OTP to: {{sentOtp.sentToLocation}}</a>
					</li>
					<li *ngIf="channel != sentOtp.sentViaChannel">
						<a class="btn btn-link btn-sm" (click)="reSend(channel)">Send an {{channel}} with your OTP.</a>
					</li>
				</ng-container>
			</ul>
		</ng-container>


		<div class="btn-group w-100 mt-3">
			<a class="btn btn-outline-secondary" (click)="reset()">Back</a>
			<button class="w-75 btn btn-primary" type="submit" [disabled]="form.invalid" *ngIf="submitting == false">Next</button>
			<button class="w-75 btn btn-primary" type="submit" [disabled]="true" *ngIf="submitting == true">
				<i nz-icon nzType="loading" nzTheme="outline"></i>
			</button>
		</div>
	</form>
</div>
